/**
 * Notification links are stored as plain strings and may carry a query string
 * (e.g. "/schedule?offer=<id>"). TanStack Router does not split a query out of
 * `to`, so navigation options are built here and reused by every consumer.
 */
export type NotificationNavigation = {
  to: string;
  search?: Record<string, string>;
};

export function notificationNavigation(link: string): NotificationNavigation {
  const [path, query] = link.split("?");
  if (!query) return { to: path };
  const search: Record<string, string> = {};
  for (const [k, v] of new URLSearchParams(query).entries()) {
    if (k) search[k] = v;
  }
  return { to: path, search };
}
